var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3725_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 17.7272L17.1291 20.8819C17.2622 20.9627 17.4162 21.0022 17.5718 20.9955C17.7274 20.9887 17.8774 20.936 18.003 20.844C18.1287 20.752 18.2242 20.6248 18.2775 20.4786C18.3309 20.3323 18.3397 20.1735 18.3028 20.0222L16.9078 14.1356L21.4734 10.1981C21.5898 10.0959 21.6738 9.96184 21.7149 9.81248C21.7559 9.66311 21.7524 9.50498 21.7046 9.35761C21.6569 9.21025 21.567 9.08009 21.4461 8.98322C21.3252 8.88635 21.1786 8.82699 21.0244 8.81249L15.0328 8.32499L12.7247 2.73749C12.6658 2.59334 12.5654 2.46998 12.4362 2.38315C12.3069 2.29631 12.1548 2.24994 11.9991 2.24994C11.8434 2.24994 11.6912 2.29631 11.562 2.38315C11.4327 2.46998 11.3323 2.59334 11.2734 2.73749L8.96531 8.32499L2.97375 8.81249C2.81847 8.82613 2.67065 8.88522 2.54876 8.98238C2.42686 9.07954 2.3363 9.21047 2.28839 9.3588C2.24048 9.50714 2.23734 9.6663 2.27937 9.81641C2.3214 9.96652 2.40672 10.1009 2.52469 10.2028L7.09031 14.1403L5.69531 20.0222C5.65844 20.1735 5.66723 20.3323 5.72059 20.4786C5.77394 20.6248 5.86947 20.752 5.99508 20.844C6.1207 20.936 6.27077 20.9887 6.42634 20.9955C6.5819 21.0022 6.73596 20.9627 6.86907 20.8819L11.9991 17.7272Z",
    fill: "#FFE500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3725_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.05af2bb2b0cd74344af25146706aeffb.svg";
export { ForwardRef as ReactComponent };